import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './DeleteDialogContent.module.scss'

interface IProps {
  onDelete: () => void
  onClose: () => void
}

export const DeleteDialogContent = ({ onDelete, onClose }: IProps) => {
  return (
    <div className={styles.root}>
      <WidgetHeader>jbp-commitment-delete-dialog-title</WidgetHeader>
      <Translation text={'jbp-commitment-delete-dialog'} />
      <div className={styles.btns}>
        <Button className={styles.btns__btn} onClick={onDelete}>
          <Translation text={'jbp-commitment-delete-dialog-delete'} />
        </Button>
        <Button color={'grey'} onClick={onClose}>
          <Translation text={'jbp-commitment-delete-dialog-cancel'} />
        </Button>
      </div>
    </div>
  )
}
